import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const Loader = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
        </div>
    );
};
